import { mapAutoYear } from './mapAutoYear';
import type { TPropertyKey } from './propertyKey';
import { formatKey } from './propertyKey';

export const mapAutoManufactureYears = (
  key: TPropertyKey,
  years?: number[] | null,
): Dictionaries.TObjectStore<number, Dictionaries.TSelectOption> => {
  const formattedKey = formatKey(key);
  if (!formattedKey) {
    return {};
  }
  return {
    [formattedKey]: years?.map(mapAutoYear) ?? [],
  };
};
